import * as React from "react";
import { useTranslation } from "react-i18next";
import { NavLink, useRouteMatch } from "react-router-dom";
import { IHomeHeaderMegaMenu } from "../../models/interfaces/home-header-menu.interface";

type HomeHeaderMegaMenuProps = {
  megaMenu: IHomeHeaderMegaMenu;
  parentRouteUrl: string;
};

const HomeHeaderMegaMenu = (props: HomeHeaderMegaMenuProps) => {
  const { megaMenu, parentRouteUrl } = props;
  const { t } = useTranslation();
  const match = useRouteMatch();

  const IMG = (imgName: string) => {
    return require(`./../../../../../../assets/images/svg/${imgName}.svg`)
      ?.default;
  };

  return (
    <div className="flex p-2 bg-white">
      <div className="grid grid-flow-row grid-cols-2 gap-4 w-96">
        {megaMenu &&
          megaMenu.items?.length > 0 &&
          megaMenu.items.map((menu: any, menuIndex: number) => (
            <div key={menuIndex}>
              <div className="w-auto mb-1 text-sm font-semibold">
                {t(menu.headingLabelKey)}
              </div>
              <div className="flex flex-col">
                {menu?.subMenus &&
                  menu?.subMenus.map((subMenu: any, subMenuindex: number) => (
                    <NavLink
                      key={subMenuindex}
                      to={match.url + parentRouteUrl + subMenu.routeUrl}
                      className="my-0.5 text-xs hover:text-blue-700"
                      activeClassName=""
                    >
                      {t(subMenu.labelKey)}
                    </NavLink>
                  ))}
              </div>
            </div>
          ))}
      </div>
      <div className="flex items-center justify-center w-72">
        <img className="w-44 h-44" src={IMG(megaMenu.image)} alt=""></img>
      </div>
    </div>
  );
};

export default HomeHeaderMegaMenu;
